/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPPOSTALADDRESSTYPE = {
    Street: '1',
    PoBox: '2',
    PrivateBag: '3'
} as const;
export type IAPPOSTALADDRESSTYPE = typeof IAPPOSTALADDRESSTYPE[keyof typeof IAPPOSTALADDRESSTYPE];


export function IAPPOSTALADDRESSTYPEFromJSON(json: any): IAPPOSTALADDRESSTYPE {
    return IAPPOSTALADDRESSTYPEFromJSONTyped(json, false);
}

export function IAPPOSTALADDRESSTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPPOSTALADDRESSTYPE {
    return json as IAPPOSTALADDRESSTYPE;
}

export function IAPPOSTALADDRESSTYPEToJSON(value?: IAPPOSTALADDRESSTYPE | null): any {
    return value as any;
}

